import { type FC, useId } from 'react';
import {
    Cell,
    ClickableIcon,
    IconEditFilled,
    IconOpenInNewTab,
    IconSelectFilled,
    Label,
    MiniGrid,
    MiniGridRow,
    Text,
    TextCell,
} from '@direct-frontend/components';
import { openInNewTab } from '#shared/lib/router';

interface ConnectedStatusRowProps {
    serviceUrl: string;
}

export const ConnectedStatusRow: FC<ConnectedStatusRowProps> = ({ serviceUrl }) => (
    <MiniGridRow id="status" data-testid="SiteVerificationMiniGrid.StatusRow">
        <TextCell
            title={(textProps) => (
                <Text {...textProps} color="gray" role="supplementary">
                    Статус
                </Text>
            )}
        />
        <Cell leftPadding={false} type="Label">
            <Label addonLeft={<IconSelectFilled role="main" color="green" size="12" />} size="3xs">
                Подключено
            </Label>
        </Cell>
        <Cell type="Icon" isGrowable={false}>
            <ClickableIcon
                title="Открыть в новой вкладке"
                onClick={() => openInNewTab(serviceUrl)}
                role="supplementary"
            >
                <IconOpenInNewTab size="20" />
            </ClickableIcon>
        </Cell>
    </MiniGridRow>
);

interface VerificationCodeRowProps {
    onEdit: VoidFunction;
    verificationCode: string;
}

export const VerificationCodeRow: FC<VerificationCodeRowProps> = ({ onEdit, verificationCode }) => (
    <MiniGridRow id="verification-code" data-testid="SiteVerificationMiniGrid.VerificationCodeRow">
        <TextCell
            title={(textProps) => (
                <Text {...textProps} color="gray" role="supplementary">
                    Код верификации
                </Text>
            )}
        />
        <TextCell leftPadding={false} title={verificationCode} />
        <Cell type="Icon" isGrowable={false}>
            <ClickableIcon title="Изменить код верификации" onClick={onEdit} role="supplementary">
                <IconEditFilled size="20" />
            </ClickableIcon>
        </Cell>
    </MiniGridRow>
);

type VerificationCodeMiniGridProps = VerificationCodeRowProps;

export const VerificationCodeMiniGrid: FC<VerificationCodeMiniGridProps> = (props) => {
    const id = useId();

    return (
        <MiniGrid id={id} data-testid="SiteVerificationMiniGrid">
            <VerificationCodeRow {...props} />
        </MiniGrid>
    );
};
